import { useEffect, useRef } from "react";

export default function usePauseOnOutOfView() {
    const sectionRef = useRef(null);

    useEffect(() => {
        if (!sectionRef.current) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                // Pause / resume bubbles
                const bubbles = sectionRef.current.querySelector(".bg-bubbles");
                if (bubbles) {
                    bubbles.classList.toggle("paused", !entry.isIntersecting);
                }

                // Pause / resume glow
                const glow = sectionRef.current.querySelector(".glow-bg");
                if (glow) {
                    glow.classList.toggle("paused", !entry.isIntersecting);
                }
            },
            { threshold: 0.15 }
        );

        observer.observe(sectionRef.current);
        return () => observer.disconnect();
    }, []);

    return sectionRef;
}
